const GrenadaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111508)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#FFDA44"
      />
      <path
        d="M8.72803 3.47828C11.9378 1.28406 15.8189 0 20.0004 0C24.182 0 28.0631 1.28406 31.2729 3.47828L20.0004 4.34781L8.72803 3.47828Z"
        fill="#A2001D"
      />
      <path d="M20.0006 20L18.7242 18.7236L18.3853 19.3307L20.0006 20Z" fill="#0052B4" />
      <path
        d="M5.85785 5.85742C-1.95262 13.6679 -1.95262 26.3312 5.85785 34.1418C9.08543 30.9142 12.1896 27.8101 20 19.9996L5.85785 5.85742Z"
        fill="#496E2D"
      />
      <path
        d="M34.1422 5.85742C41.9527 13.6679 41.9527 26.3312 34.1422 34.1418C30.9146 30.9142 27.8105 27.8101 20 19.9996L34.1422 5.85742Z"
        fill="#496E2D"
      />
      <path
        d="M19.9999 26.9559C23.8419 26.9559 26.9564 23.8414 26.9564 19.9995C26.9564 16.1575 23.8419 13.043 19.9999 13.043C16.158 13.043 13.0435 16.1575 13.0435 19.9995C13.0435 23.8414 16.158 26.9559 19.9999 26.9559Z"
        fill="#A2001D"
      />
      <path
        d="M19.9999 13.043L21.5592 17.8421H26.6059L22.5233 20.8088L24.0826 25.6081L19.9999 22.642L15.9171 25.6081L17.4767 20.8088L13.394 17.8421H18.4404L19.9999 13.043Z"
        fill="#FFDA44"
      />
      <path
        d="M20.0062 0H19.9929C14.4731 0.00179688 9.47613 2.23953 5.8584 5.85688H34.1407C30.5229 2.23953 25.5259 0.00179688 20.0062 0Z"
        fill="#A2001D"
      />
      <path
        d="M5.8584 34.1426C9.47762 37.7613 14.4771 39.9994 19.9994 39.9994C25.5217 39.9994 30.5212 37.7613 34.1404 34.1426H5.8584Z"
        fill="#A2001D"
      />
      <path
        d="M19.9999 2.17285L20.3237 3.16926H21.3714L20.5238 3.78512L20.8476 4.78152L19.9999 4.16574L19.1523 4.78152L19.4762 3.78512L18.6284 3.16926H19.6761L19.9999 2.17285Z"
        fill="#FFDA44"
      />
      <path
        d="M15.1498 2.17285L15.4736 3.16926H16.5213L15.6737 3.78512L15.9975 4.78152L15.1498 4.16574L14.3023 4.78152L14.6261 3.78512L13.7783 3.16926H14.826L15.1498 2.17285Z"
        fill="#FFDA44"
      />
      <path
        d="M24.849 2.17285L25.1729 3.16926H26.2205L25.3729 3.78512L25.6968 4.78152L24.849 4.16574L24.0014 4.78152L24.3253 3.78512L23.4775 3.16926H24.5252L24.849 2.17285Z"
        fill="#FFDA44"
      />
      <path
        d="M19.9999 35.2168L20.3237 36.2132H21.3714L20.5238 36.8291L20.8476 37.8255L19.9999 37.2096L19.1523 37.8255L19.4762 36.8291L18.6284 36.2132H19.6761L19.9999 35.2168Z"
        fill="#FFDA44"
      />
      <path
        d="M15.1498 35.2168L15.4736 36.2132H16.5213L15.6737 36.8291L15.9975 37.8255L15.1498 37.2096L14.3023 37.8255L14.6261 36.8291L13.7783 36.2132H14.826L15.1498 35.2168Z"
        fill="#FFDA44"
      />
      <path
        d="M24.849 35.2168L25.1729 36.2132H26.2205L25.3729 36.8291L25.6968 37.8255L24.849 37.2096L24.0014 37.8255L24.3253 36.8291L23.4775 36.2132H24.5252L24.849 35.2168Z"
        fill="#FFDA44"
      />
      <path
        d="M6.09374 19.6699C6.60741 20.4815 6.36601 21.5558 5.55437 22.0696C4.7428 22.5833 3.66843 22.3419 3.15468 21.5303C2.2246 20.0609 2.7639 17.6611 2.7639 17.6611C2.7639 17.6611 5.16358 18.2004 6.09374 19.6699Z"
        fill="#FFDA44"
      />
      <path
        d="M5.08926 22.2039C5.56949 22.2039 5.95879 21.8146 5.95879 21.3344C5.95879 20.8541 5.56949 20.4648 5.08926 20.4648C4.60903 20.4648 4.21973 20.8541 4.21973 21.3344C4.21973 21.8146 4.60903 22.2039 5.08926 22.2039Z"
        fill="#A2001D"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111508">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default GrenadaSvg;
